import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
          <p className="text-sm text-designColor tracking-[4px]">2022 - PRESENT</p>
        </div>
        <div className="mt-6 ml-[10px] lgl:ml-[100px] lgl:mt-14 lgl:w-[1100px] w-[320px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
        <ResumeCard
            title="Web Developer"
            subTitle="April 2024 - Present"
            result="Afame Technologies"
            des="Ongoing Internship"
          />
        <ResumeCard
            title="Full-Stack Web Developer"
            subTitle="February 2024 - March 2024"
            result="Techplement"
            des="Made a Fitness Tracker App along with a team. Learned how to work with a team while developing a website"
          />
          <ResumeCard
            title="Jr. Executive"
            subTitle="September 2022 - January 2023"
            result="Fortress Infracon Pvt. Ltd."
            des="Supported the IT Team & helped them look for projetcs. as well helped them to visualize the data with the help of PowerBI, Ms Excel and Some Front-end technologies"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
